import { IGeneralPreferences } from '../interfaces';

export const CABINET_PREFERENCES_LOCAL_STORAGE_KEY = 'cabinetPreferences';
export const DEFAULT_GENERAL_CABINET_PREFERENCES: IGeneralPreferences = {
    metricLevel: 'frozen',
};
